import { TypePriority } from '../../interfaces'
import { TypePriorityAction } from '../actions/typePriorityActions'
import { GET_TYPE_PRIORITY_EXITO } from '../types/typePriorityActionsTypes'

export interface TypePriorityState {
  typesPriorityState: {
    typesPriority?: TypePriority[]
    error?: string
  }
}

const initialState: TypePriorityState = {
  typesPriorityState: { typesPriority: [], error: '' }
}

export const typesPriorityReducer = (
  state: TypePriorityState = initialState,
  action: TypePriorityAction
): TypePriorityState => {
  if (action.type === GET_TYPE_PRIORITY_EXITO) {
    return {
      ...state,
      typesPriorityState: {
        typesPriority: action.typesPriority,
        error: action.error
      }
    }
  }
  return state
}
